import React from 'react';
import { changedStyles } from '../WatchlistTableHelpers';
import { useSelector } from 'react-redux';

export default function WordStatus(props) {
  const value = props.value?.word;
  const isColorEnable = useSelector(state => state.User.user?.enable_watchlist_color ?? false);

  return (
    <div style={{ textAlign: 'center', display: 'inline-flex', width: '100%', justifyContent: 'center' }}>
      {isColorEnable ? (
        <div
          style={{
            height: '20px',
            lineHeight: '21px',
            borderRadius: '.2rem',
            fontSize: '70%',
            fontWeight: 700,
            ...changedStyles[value?.toLowerCase()],
          }}>
          {value}
        </div>
      ) : (
        value
      )}
    </div>
  );
}
